import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ArrowLeft from 'src/assets/images/LeftArrowBlue.svg';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import Backdrop from 'src/common/refactoredComponents/backdrop/Backdrop';
import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import {
    BackButton,
    BackButtonIcon,
    BackText,
    MainContainer,
    ShippingContainer,
    ShippingContainerSize,
    Title,
    LookUpButton,
    TotalCount,
    SearchedItem,
    AccountNameHeader,
    AccountFilterList,
    AccountIdHeader,
    AdvanceSelectButton,
} from './ShipAddressModal.styled';
import { getDropdownValues } from 'src/pages/scheduleSurgery/redux/actions';
import InputBox from 'src/common/refactoredComponents/input/Input';
import { setSelectAccount } from '../../../redux/action/actionCreators';
import BottomNavigation from 'src/common/refactoredComponents/bottomNavigation/BottomNavigation';
import { LineSeparator } from './ShipAddressModal.styled';
import { CommonEmptyBox } from 'src/styles/CommonStyles.styled';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { logErrorToConsole } from 'src/utils/util';

const AdvanceAccountSearch = ({
    handleTerritoryValue,
    advanceSearchValue,
    setAdvanceSearchValue,
    setSelectedList,
    selectedList,
}) => {
    const { t } = useTranslation();
    const [accountCity, setAccountCity] = useState('');
    const [accountState, setAccountState] = useState('');
    const [valueChange, setValueChange] = useState(false);
    const [enableAddressButton] = useState(false);
    const [enableLookUpButton, setEnableLookUpButton] = useState(false);
    const [accountsList, setAccountsList] = useState([]);
    const [currentSelectedItem, setCurrentSelectedItem] = useState(null);
    const [isDisabled, setIsDisabled] = useState(true);

    const dispatch = useDispatch();

    const { accounts, loading } = useSelector((state) => ({
        accounts: state.detailsDropdownsReducer.accountLookup.items,
        loading: state.detailsDropdownsReducer.accountLookup.loading,
    }));

    useEffectWithErrorLogging(() => {
        setAccountsList(accounts);
    }, [accounts]);

    useEffectWithErrorLogging(() => {
        if (
            accountCity === '' &&
            accountState === '' &&
            accountsList.length === 0
        ) {
            setIsDisabled(true);
        }
        if (
            accountCity === '' &&
            accountState !== '' &&
            accountsList.length !== 0
        ) {
            setIsDisabled(true);
        }
        if (
            accountCity !== '' &&
            accountState === '' &&
            accountsList.length !== 0
        ) {
            setIsDisabled(true);
        }
        if (
            accountCity !== '' &&
            accountState !== '' &&
            accountsList.length !== 0
        ) {
            setIsDisabled(true);
        }
    }, [accountCity, accountState, enableAddressButton]);

    useEffectWithErrorLogging(() => {
        if (accountCity === '' && accountState === '') {
            setEnableLookUpButton(false);
        }
        if (accountCity === '' && accountState !== '') {
            setEnableLookUpButton(true);
        }
        if (accountCity !== '' && accountState === '') {
            setEnableLookUpButton(true);
        }
        if (accountCity !== '' && accountState !== '') {
            setEnableLookUpButton(true);
        }
    }, [accountCity, accountState]);

    const lookupAccount = () => {
        let filteredArray = [];
        if (accountState !== '' && accountCity == '') {
            dispatch(
                getDropdownValues({
                    dropDownName: 'accountLookup',
                    value: { accountState: accountState },
                })
            );
            if (accountsList.length !== 0) {
                filteredArray = accountsList.filter((item) => {
                    return (
                        item.address?.state
                            ?.toLowerCase()
                            .indexOf(accountState?.toLowerCase()) !== -1
                    );
                });
            }
            setAccountsList(filteredArray);
        }
        if (accountCity !== '' && accountState == '') {
            dispatch(
                getDropdownValues({
                    dropDownName: 'accountLookup',
                    value: { accountCity: accountCity },
                })
            );
            if (accountsList.length !== 0) {
                filteredArray = accountsList.filter((item) => {
                    return (
                        item.address?.city
                            ?.toLowerCase()
                            .indexOf(accountCity?.toLowerCase()) !== -1
                    );
                });
            }
            setAccountsList(filteredArray);
        }
        if (accountCity !== '' && accountState !== '') {
            dispatch(
                getDropdownValues({
                    dropDownName: 'accountLookup',
                    value: {
                        accountCity: accountCity,
                        accountState: accountState,
                    },
                })
            );
            if (accountsList.length !== 0) {
                filteredArray = accountsList.filter((item) => {
                    return (
                        item.address?.state
                            ?.toLowerCase()
                            .indexOf(accountState?.toLowerCase()) !== -1 &&
                        item.address?.city
                            ?.toLowerCase()
                            .indexOf(accountCity?.toLowerCase()) !== -1
                    );
                });
            }
            setAccountsList(filteredArray);
        }
        if (accountCity == '' && accountState == '') {
            setAccountsList([]);
        }
        setValueChange(true);
    };

    const searchedItem = () => {
        if (accountState !== '' && accountCity == '') {
            return <>{`"${accountState}"`}</>;
        }
        if (accountCity !== '' && accountState == '') {
            return <>{`"${accountCity}"`}</>;
        }
        if (accountCity !== '' && accountState !== '') {
            return <>{`"${accountCity}" and "${accountState}"`}</>;
        }
    };

    const selectAccount = () => {
        setSelectedList(currentSelectedItem);
        dispatch(setSelectAccount(selectedList));
        setAdvanceSearchValue(!advanceSearchValue);
    };
    return (
        <div>
            <LineSeparator />
            <BackButton
                id="reportUsage-replen-selectShipToAddress-backButton"
                onClick={handleTerritoryValue}
            >
                <BackButtonIcon>
                    <img src={ArrowLeft}></img>
                </BackButtonIcon>
                <BackText>
                    <span>{t('reportUsage.replen.selectShipToAddress.backText')}</span>
                </BackText>
            </BackButton>
            <MainContainer>
                <ShippingContainer>
                    <ShippingContainerSize>
                        <Title showAstrisk={false}>{t('reportUsage.replen.selectShipToAddress.accountCity')}</Title>
                        <InputBox
                            placeholder={t(
                                'reportUsage.replen.selectShipToAddress.AdvanceAccountSearch.accountCity'
                            )}
                            id={'reportUsage-replen-selectShipToAddress-advanceAccountSearch-accountCity'}
                            onChange={(e) => {
                                setAccountCity(e.target.value);
                                setAccountsList(accounts);
                                setValueChange(false);
                            }}
                        />
                    </ShippingContainerSize>
                    <ShippingContainerSize>
                        <Title showAstrisk={false}>
                            {t('reportUsage.replen.selectShipToAddress.accountStateAbbreviation')}
                        </Title>
                        <InputBox
                            placeholder={t(
                                'reportUsage.replen.selectShipToAddress.AdvanceAccountSearch.ny'
                            )}
                            id={'reportUsage-replen-selectShipToAddress-advanceAccountSearch-accountState'}
                            onChange={(e) => {
                                setAccountState(e.target.value),
                                    setAccountsList(accounts);
                                setValueChange(false);
                            }}
                        />
                    </ShippingContainerSize>
                </ShippingContainer>
                {loading && (
                    <Backdrop
                        showCloseButton={false}
                        showBackdrop={true}
                        isModal
                        loaderBackground
                    >
                        <Spinner
                            id="reportUsage-advanceAccountSearch-backdrop-loadingSpinner"
                            animation="border"
                            variant="primary"
                            small
                        />
                    </Backdrop>
                )}
                <LookUpButton>
                    <Button
                    id={'reportUsage-replen-lookupAccount'}
                        // secondary={enableLookUpButton}
                        variant={enableLookUpButton ? ButtonStyles?.secondary : ButtonStyles?.disabled}
                        width="270px"
                        mobileWidth="100%"
                        height="38px"
                        padding="0.625rem"
                        // fontSize="15px"
                        show={true}
                        clicked={lookupAccount}
                        disabled={!enableLookUpButton}
                    >
                        <div>{t('reportUsage.replen.selectShipToAddress.lookupAccount')}</div>
                    </Button>
                </LookUpButton>
            </MainContainer>

            {valueChange && accountsList.length > 1 && loading === false ? (
                <TotalCount fontSize={'16px'}>
                    {accountsList.length} {t('orders.searchResultsPanel.Resultsfor')}
                    <SearchedItem phoneLable={false}>
                        {' '}
                        {searchedItem()}{' '}
                    </SearchedItem>
                </TotalCount>
            ) : null}

            {valueChange && accountsList.length <= 1 && loading === false ? (
                <TotalCount fontSize={'16px'}>
                    {accountsList.length} {t('orders.searchResultsPanel.Resultsfor')}
                    <SearchedItem phoneLable={false}>
                        {' '}
                        {searchedItem()}{' '}
                    </SearchedItem>
                </TotalCount>
            ) : null}

            {valueChange && !loading
                ? accountsList.length !== 0 && !loading
                    ? accountsList.map((item) => {
                          return (
                              <AccountFilterList
                                  id={`account-filter-list-${item.accountId}`}
                                  onClick={() => {
                                    try {
                                      setCurrentSelectedItem(item);
                                      setIsDisabled(false);
                                       } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                  }}
                                  key={item.accountId}
                              >
                                  <div
                                      className="accountList"
                                      tabIndex={item.accountId}
                                  >
                                      <AccountNameHeader>
                                          {item.accountName}{' '}
                                          <AccountIdHeader>
                                              {item.accountId.replace(
                                                  /^0+/,
                                                  ''
                                              )}
                                          </AccountIdHeader>
                                      </AccountNameHeader>
                                      <StyledDiv>
                                          <ShippingContainer>
                                              <AccountIdHeader
                                                  color={'#000000'}
                                                  fontSize={'13px'}
                                                  fontFamily={
                                                      'AvenirNextWorld Regular'
                                                  }
                                              >
                                                  <div>
                                                      {
                                                          item.address
                                                              .addressLine1
                                                      }
                                                  </div>
                                                  <div>{`${item.address.city}, ${item.address.state}`}</div>
                                              </AccountIdHeader>
                                          </ShippingContainer>
                                          <div>
                                              <StyledPhoneFax>
                                                  {item?.phone ? (
                                                      <>
                                                          {' '}
                                                          <SearchedItem
                                                              phoneLable={true}
                                                              fontSize={'13px'}
                                                          >
                                                              {t('reportUsage.replen.selectShipToAddress.phone')}
                                                          </SearchedItem>
                                                          <SearchedItem
                                                              phoneLable={true}
                                                              fontSize={'13px'}
                                                          >
                                                              {item.phone}
                                                          </SearchedItem>
                                                      </>
                                                  ) : null}
                                              </StyledPhoneFax>
                                              <StyledPhoneFax>
                                                  {item?.fax ? (
                                                      <>
                                                          {' '}
                                                          <SearchedItem
                                                              phoneLable={true}
                                                              fontSize={'13px'}
                                                          >
                                                              {t('reportUsage.replen.selectShipToAddress.fax')}
                                                          </SearchedItem>
                                                          <SearchedItem
                                                              phoneLable={true}
                                                              fontSize={'13px'}
                                                          >
                                                              {item.fax}
                                                          </SearchedItem>
                                                      </>
                                                  ) : null}
                                              </StyledPhoneFax>
                                          </div>
                                      </StyledDiv>
                                  </div>
                              </AccountFilterList>
                          );
                      })
                    : null
                : null}
            <CommonEmptyBox mobileMargin={'40%'} />
            <BottomNavigation
                justifyContent={'flex-end'}
                opacity={'1'}
                position={'absolute'}
                mbPosition={'fixed'}
                isIPadPotrait={true}
                iPadPortraitFooterPosition={'absolute'}
                padding={'5px'}
                right={'0'}
            >
                <AdvanceSelectButton
                    marginLeft={'22px !important'}
                    marginRight={'26px !important'}
                >
                    <Button
                    id={'reportUsage-replen-lookupAccountButton'}
                        show={true}
                        // primary={!isDisabled}
                        variant={!isDisabled ? ButtonStyles?.primary : ButtonStyles.disabled}
                        disabled={isDisabled}
                        width={'181px'}
                        height={'38px'}
                        clicked={selectAccount}
                        margin={'5px'}
                        // fontSize={'15px'}
                        mobileWidth="100%"
                    >
                    {t('reportUsage.replen.selectShipToAddress.selectAccountButton')}
                    </Button>
                </AdvanceSelectButton>
            </BottomNavigation>
        </div>
    );
};

export default AdvanceAccountSearch;

const StyledPhoneFax = styled.div`
    margin-top: -4px;
    ${media.mobileDevice`
        margin-top: 0px;
    `};
`;

const StyledDiv = styled.div`
    display: flex;
    justify-content: space-between;
    width: 70%;
    ${media.mobileDevice`
        display: block;
        justify-content: left;
        width: 100%;
    `};
`;
